import { CustomButton, SvgOcrRejected } from '@ui-kit'
import { NAMESPACES } from '../../../utils/constants'
import { OCRRejectedPageProps } from '../../../types/ocr.types'

const OCRRejectedPage: React.FC<OCRRejectedPageProps> = ({
  onProceedManually,
  rejectionReason,
  isCaseCreationFailed,
}) => {
  const trimmedReason = rejectionReason?.trim()

  return (
    <div className="flex items-center justify-center h-full w-full">
      <div className="flex flex-col items-center gap-6 text-center max-w-xl px-4">
        <SvgOcrRejected />
        <div className="flex flex-col gap-2">
          <p className="text-base font-medium font-primary text-gray-900">
            {isCaseCreationFailed
              ? NAMESPACES.CASE_CREATION_FAILED
              : NAMESPACES.OCR_REJECTED_TITLE}
          </p>
          <p className="text-sm font-primary text-gray-600">
            {NAMESPACES.OCR_REJECTED_SUBTITLE}
          </p>
          {trimmedReason || isCaseCreationFailed ? (
            <div className="mt-2 text-left rounded border border-secondary-100 bg-secondary-25 px-3 py-2">
              <p className="text-xs font-medium font-primary text-gray-700 mb-1">
                {NAMESPACES.OCR_REJECTION_REASON_LABEL}
              </p>
              <p className="text-sm font-primary text-gray-900 whitespace-pre-wrap break-words">
                {isCaseCreationFailed
                  ? NAMESPACES.CASE_CREATION_FAILED_REASON
                  : trimmedReason}
              </p>
            </div>
          ) : null}
        </div>

        {onProceedManually && (
          <div className="mt-4">
            <CustomButton
              isFilled
              color="primary"
              className="w-44 h-8"
              onClick={onProceedManually}
            >
              {NAMESPACES.OCR_PROCEED_MANUALLY}
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  )
}

export default OCRRejectedPage
